<template lang="pug">
  div
    b-table(:data='data'
      v-if="data.length != 0"
      ref='table'
      paginated=''
      backend-pagination=''
      @page-change="pageChange"
      per-page='8'
      :loading="loadingTable"
      :narrowed="false"
      :total="totalDataTable"
      detail-key='id'
      aria-next-label='Página siguiente'
      aria-previous-label='Página anterior'
      aria-page-label='Página'
      aria-current-label='Página actual'
      )
      template(slot-scope='props')
        b-table-column(class='table--change column--1' field='updated_at' label='Modificación') {{ lastDateChange( props.row.quotations[0].updated_at,props.row.quotations[1].updated_at)}}
          template(slot="header")
            div(class="header-wrapper" ) Modificación
        b-table-column(class='table--change column--2' field='code' label='Código') {{  props.row.quotations[0].program_bag }}
          template(slot="header")
            div(class="header-wrapper") Código

        b-table-column(class='table--change column--3' field='client' label='Broker') {{ props.row.quotations[0].quotation.broker_business.name || "---" }}
          template(slot="header")
            div(class="header-wrapper") Broker

        b-table-column(class='table--change column--4'  v-if="roleExecutiveTeamSupervisor || roleNational" field='client' label='Ejecutivo') {{ props.row.assigned_executive_op || "---" }}
          template(slot="header")
            div(class="header-wrapper") Ejecutivo
        b-table-column(class='table--change column--4' v-if="roleNational" field='client' label='Supervisor') {{ props.row.assigned_executive_tsup || "---" }}
          template(slot="header")
            div(class="header-wrapper") Supervisor
        b-table-column(class='table--change column--4' field='client' label='Contratante') {{ props.row.quotations[0].quotation.client }}
          template(slot="header")
            div(class="header-wrapper") Contratante
        b-table-column(class='table--change column--5' field='created_at' label='Creación') {{ props.row.created_at | formDate }}
          template(slot="header")
            div(class="header-wrapper") Creación

        b-table-column(class='table--change column--6' field='client' label='')
          button.button--modal(@click='openModal(props.row)') Ver
    //Modal
    b-modal(:active.sync='showModal')
      .modal-program-content
        .modal-program-header
          .modal-program-code Programa {{ '#'+selectedItem.id }}
          button.modal-program-close(type='button' @click="closeModal")
            i
        .modal-program-details
          .modal-program-details-item
            h3 Broker
            p {{ selectedItem && selectedItem.quotations && selectedItem.quotations.length > 0 ? selectedItem.quotations[0].quotation.broker_business.name : '' }}
          .modal-program-details-item
            h3 Contratante
            p {{ selectedItem && selectedItem.quotations && selectedItem.quotations.length > 0 ? selectedItem.quotations[0].quotation.client : '' }}

          .modal-program-details-item
            h3 Creacion
            p {{ selectedItem.created_at | formDate }}
          .modal-program-details-item
            h3 Propietario
            reallocation-programs(
                :teamList="teamList"
                :quotation_id="selectedItem.quotations && selectedItem.quotations.length > 0 ? selectedItem.quotations[0].id : null"
                :owner="selectedItem.quotations && selectedItem.quotations.length > 0 ? selectedItem.quotations[0].owner : null"
                v-if="!roleEmission"
              )
        .modal-program-table
          table
            thead
              tr
                th.col--1 Modificación
                th.col--2 Código
                th.col--3 Ramo
                th.col--4 Recotización
                th.col--5 Estado
                th.col--6
            tbody
              tr(v-for="program in selectedItem.quotations")
                td {{ program.updated_at | formDate }}
                td {{ program.code}}
                td
                  b-tooltip(:label="'Tecnico asignado: ' + program.assigned_technical" position='is-right')
                    p {{ getBagbyName(program.name) }}
                td {{ formatRequote(program.status_detail.is_post_requote) }}
                td
                  .modal-status-button
                    span.tag(:class="getStatusClass(program.status,program.status_detail.recipient_inbox_id,program.has_technical_quote, program.status_detail.sender_inbox_id)") {{ program.status_detail.metastate_name}}
                td
                  span.modal-detail-button
                    b-button(
                      class="open-button"
                      size="is-small"
                      type="is-danger"
                      outlined
                      icon-left="eye" @click="openQuoteClickEvent(program)"
                    ) ABRIR

        .modal-program-foot
          p *Abre una cotización para cambiar el propietario de manera individual
  </template>
  
  <script>
  import {RepositoryFactory} from '@/services/RepositoryFactory';
  import { isTechnical, isExecutive, isEmission, isExecutiveNationalSupervisor, isExecutiveTeamSupervisor } from '@/mixins/user';
  import { getExecutiveList } from '../services/User/executive';
  import { getTechnicalList } from '../services/User/technical';
  import ReallocationPrograms from './ReallocationPrograms';
  import { isBroker } from '../mixins/user';
  import { getBrokerList } from '../services/User/broker';
  import moment from 'moment'
  import store from "@/store";

  const QuoteRepository = RepositoryFactory.get('quotes')
  
  export default {
  components: {
    ReallocationPrograms
  },
  props: {
    filter: {
      type: String,
      default: 'inbox',
    }
  },
  data () {
    return {
      isLoading: false,
      isloader: false,
      teamList: [],
      premiumElement: null,
      field: "",
      page:1,
      updatedSense: false,
      codeSense: false,
      premiumSense: false,
      createdSense: false,
      tableData: [],
      tableColumns: [],
      showModal: false,
      selectedItem: {}
    }
  },
  methods: {
    openModal(item) {
      this.selectedItem = item;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    lastDateChange(dateChange1, dateChange2) {
      if( dateChange1 || dateChange2 ) {
        let date1 =  new Date(dateChange1)
        let date2 =  new Date(dateChange2)
        let currentDate = new Date();
        var date1Diference = Math.abs(currentDate - date1);
        var date2Diference = Math.abs(currentDate - date2);
        if (date1Diference < date2Diference) {
          return moment(dateChange1).format('DD/MM/YYYY hh:mm A')
        } else {
          return moment(dateChange2).format('DD/MM/YYYY hh:mm A')
        }
      }
    },
    formatRequote(value) {
      let requote = ""
      value? requote ='Sí': requote ='No'
      return requote
    },
    order(field) {
      this.field = field
      if(field == "updated") {
        this.updatedSense = !this.updatedSense
        store.dispatch('getListPagePrograms', {page:this.page, querys:`&ordering=${this.updatedSense? '':'-'}${field}`})
      } else if (field == "code") {
        this.codeSense = !this.codeSense
        store.dispatch('getListPagePrograms', {page:this.page, querys:`&ordering=${this.codeSense? '':'-'}${field}`})
      } else if ( field == "reference_premium") {
        this.premiumSense = !this.premiumSense
        store.dispatch('getListPagePrograms', {page:this.page, querys:`&ordering=${this.premiumSense? '':'-'}${field}`})
      } else if ( field == "created") {
        this.createdSense = !this.createdSense
        store.dispatch('getListPagePrograms', {page:this.page, querys:`&ordering=${this.createdSense? '':'-'}${field}`})
      }
    },
    premiumformat(premium, currency) {
      if( premium ) {
        return `$ ${premium}`
      } else {
        return '---'
      }
    },
    fetchFilterBroker() {
      store.dispatch('fetchFilterBroker')
    },
    fetchDataTable() {
      store.dispatch('getListPagePrograms', {page:"1", querys:""})
    },
    pageChange(page) {
      this.$store.commit('setIsloader', false);
    },

    formatUpperCase(value) {
      const valueUpperCase = value.toUpperCase()
      return valueUpperCase
    },

    fetchData() {
      const quotes = QuoteRepository.getListPagePrograms(this.filter, 1)
      return quotes
    },

    getBagbyName(name){
      if(name ==="Programa estratégico (Multiriesgo/RC/3D)"){
        return "Responsabilidad Civil, Deshonestidad, 3D y Robo"
      }
      else{
        return "Multiriesgo e Incendio"
      }
    },

    getStatusClass (statusCode, currentInbox, hasTechnicalQuote, senderInbox ) {
      if (statusCode == 4 && (senderInbox == 1 || senderInbox == 2) )
        return 'is-broker-rejected'
      else if (statusCode == 2)
        return 'is-accepted'
      else if (isBroker() == true && (currentInbox == 2 || currentInbox == 3) )
        return 'is-lp-pending'
      else if (statusCode == 1 && currentInbox == 2 && hasTechnicalQuote == true  )
        return 'is-executive-quoted'
      else if (statusCode == 1 && currentInbox == 2 )
        return 'is-executive-pending'
      else if (statusCode == 3 && currentInbox == 1 )
        return 'is-broker-quoted'
      else if (statusCode == 1 && currentInbox == 1 )
        return 'is-broker-pending'
      else if (statusCode == 1 && currentInbox == 3 )
        return 'is-technical-pending'
      else if (statusCode == 5 && senderInbox == 3 )
        return 'is-technical-rejected'
      else if (statusCode == 5 && senderInbox == 2 )
        return 'is-executive-rejected'
      else if (statusCode == 5)
        return 'is-rejected'
    },

    openQuoteClickEvent(product) {
      this.$router.push({ name: 'QuotationDetail', params: { id: product.id }})
    },

    getTeamExecutiveList() {
      getExecutiveList('team/').then((result) => {
        this.teamList = result.data;
        store.commit('setTeamList', this.teamList)
      })
    },

    getTeamTechnicalList() {
      getTechnicalList('assignable/').then((result) => {
        this.teamList = result.data;
      })
    },

    getTeamBrokerList() {
      getBrokerList('team/').then((result) => {
        this.teamList = result.data;
      })
    }
  },
  mounted(){
    
  },
  async mounted() {
    store.commit('setCurrentTray', this.filter);
    await this.fetchDataTable();
    isExecutive() ? this.getTeamExecutiveList() : null;
    isTechnical() ? this.getTeamTechnicalList() : null;
    isBroker() ? this.getTeamBrokerList() : null;
    await this.fetchFilterBroker();
  },
  computed: {
    roleEmission() {
      return isEmission();
    },
    
    rolTechnical() {
      return isTechnical();
    },
    data() {
      return store.state.dataTablePrograms
    },
    loadingTable() {
      return store.state.isloader
    },
    totalDataTable() {
      return store.state.countDataTablePrograms
    },
    showNoFoundFilter() {
      return !store.state.thereFilterResults
    },
    roleNational() {
      return isExecutiveNationalSupervisor()
    },
    roleExecutiveTeamSupervisor() {
      return isExecutiveTeamSupervisor()
    },
  }
}
  </script>
  
  <style lang="scss" scoped>
  @import '../assets/scss/variables.scss';
    .b-table {
      .table {
        th {
          text-transform: uppercase;
          padding: 1em 0.75em;
        }
        td {
          font-weight: 300;
          padding: 1em 0.75em;
          font-size: 12px;
        }
      }
    }
    .is-warning {
      background-color: $primary;
    }
    .button-wrapper{
      display: flex;
      align-items: flex-end;
    }
    .open-button{
      border-radius: 4px !important;
    }
    .field {
      font-weight: 300;
      font-size: 0.9em;
    }
    .notfoundfilter-wrapper {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 30px;
    }
    .image-wrapper {
      height: 150px;
      width: 150px;
    }
    .title-wrapper {
      font-size: 20px;
      font-weight: bold;
    }
    .title-content {
      font-size: 16px;
    }
    .header-wrapper {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      font-size: 14px;
    }
    .header-grid {
      color: black;
    }

    .b-table .table th .th-wrap{
      font-size: 14px;
    }

    .table--change{
      &.column--1{
        width: 15%;
      }
      &.column--2{
        width: 8%;
      }
      &.column--3{
        width: 28.5%;
      }
      &.column--4{
        width: 28.5%;
      }
      &.column--5{
        width: 14%;
      }
      &.column--6{
        width: 6%;
      }
    }

    .button--modal{
      position: relative;
      background: none;
      appearance: none;
      border: none;
      color: #00CEC5;
      font-weight: 600;
      font-size: 12px;
      display: flex;
      align-items: center;
    }

    .button--modal:before{
      content:"";
      background-image: url("../assets/images/eye.svg");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 0 0;
      width: 16px;
      height: 19px;
      display: block;
      margin-right: 5px;
    }

    .modal-program-content {
      width: 100%;
      height: 488px;
      background-color: #fff;
      padding: 32px;
      box-sizing: border-box;
    }

    .modal-program-code{
      font-weight: 600;
      font-size: 20px;
      line-height: 26px;
      color: #272B30;
    }

    .modal-program-details{
      margin-top: 32px;
      background-color: #F8F8F8;
      display: flex;
      flex-wrap: wrap;
      padding: 8px 16px;
      box-sizing: border-box;
    }

    .modal-program-details-item{
      width: 50%;
      padding: 8px 0;
    }

    .modal-program-details-item h3{
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #272B30;
    }

    .modal-program-details-item p{
      font-size: 16px;
      line-height: 22px;
      color: #272B30;
    }

    .modal-program-close{
      display: block;
      position: absolute;
      top: 32.5px;
      right: 32.5px;
      width: 24px;
      height: 24px;
      background: none;
      border: none;
      appearance: none;
      border-radius: 0;
      background-image: url("../assets/images/close.svg");
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .modal-program-table{
      padding-top: 32px;
    }

    .modal-program-foot{
      padding-top: 32px;
      font-size: 12px;
      line-height: 18px;
      color: #000;
    }

    .modal-program-table table{
      width: 100%;
    }

    .modal-program-table thead tr{
      border-bottom: 1px solid #D3D3D3;
    }
    .modal-program-table thead th{
      vertical-align: middle;
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      color: #272B30;
      padding: 0 8px 8px 8px;
    }

    .modal-program-table thead th.col--1{
      width: 15%;
    }
    .modal-program-table thead th.col--2{
      width: 10%;
    }
    .modal-program-table thead th.col--3{
      width: 35%;
    }
    .modal-program-table thead th.col--4{
      width: 13%;
    }
    .modal-program-table thead th.col--5{
      width: 17%;
    }
    .modal-program-table thead th.col--6{
      width: 10%;
    }

    .modal-program-table tbody tr{
      border-bottom: 1px solid #D3D3D3;
    }

    .modal-program-table tbody tr:last-child{
      border-bottom: none;
    }

    .modal-program-table tbody td{
      vertical-align: middle;
      font-size: 12px;
      line-height: 18px;
      color: #272B30;
      padding: 8px 8px 8px 8px;
    }

    .modal-detail-button{
      display: inline-block;
      max-width: 92px;
      width: 100%;
    }

    .modal-detail-button button{
      height: 40px;
      width: 100%;
    }

    .modal-status-button{
      max-width: 136px;
      width: 100%;
      text-align: center;
    }

    .modal-status-button .tag:not(body) {
      width: 100%;
    }

  </style>
  